<template>
    <ProductOverview v-editable="blok" :blok="blok" />
</template>

<script setup lang="ts">
defineProps<{ blok: any }>();
</script>

<style lang="postcss" scoped></style>
